$(document).on('click','.ad_to_cart',function(){
  var obj=$(this);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: $(this).attr("var_id")
    },
    dataType: 'json',
    success: function (data) {
      window.location.href='https://foptics.club/cart';
    }
  });
})

$(document).ready(function() {
  /* PRODUCT FLOW FUNCTION */
  var productId = $('.prescription-product-customer').data('prescription-product');
  var productUrl = $('.prescription-product-customer').data('product-url');
  var customerId = $('.prescription-product-customer').data('prescription-customer');
  // Step 1 next to step 2
  $('.btn-to-step2').on('click', function(e) {
    e.preventDefault();
    updateProgressBar(1, '');
    goToNextStep(2);
  });

  // Choose type of lens on step 2
  $('.product-step-2 .option-list > ul > li').on('click', function(e) {
    e.preventDefault();
    var type = 'type-of-lens';
    var title = $(this).find('h4').text();
    var variantName = $(this).find('h4').data('name');
    sessionStorage.setItem('prod-type-of-lens-' + productId, title);
    changeVariant(type, variantName);
    updateProgressBar(2, title);
    // hide unavailable option on next step
    $('.product-step-3 .option-list > ul > li').addClass('hidden');
    $('.product-step-3 .option-list h4').each(function() {
      var longOption = variantName.trim() + ' / ' + $(this).data('name') + ' /';
      var self = this;
      $('select#ProductSelect-product-template option').each(function() {
        if ($(this).text().trim().indexOf(longOption) == 0) {
          $(self).closest('li').removeClass('hidden');
        }
      });
    });
    // update price label of lens index follow type of lens
    $('.product-step.product-step-3 .option-content-title .price-label').addClass('hidden');
    $('.product-step.product-step-3 .option-content-title .price-label[data-name="'+ variantName +'"]').removeClass('hidden');
    goToNextStep(3);
  });

  // Choose lens index on step 3
  $('.product-step-3 .option-list > ul > li').on('click', function(e) {
    e.preventDefault();
    var type = 'lens-index';
    var title = $(this).find('h4').text();
    var variantName = $(this).find('h4').data('name');
    sessionStorage.setItem('prod-lens-index-' + productId, title);
    if ($(this).hasClass('is-no-degree')) {
      sessionStorage.setItem('is-no-degree-' + productId, true);
    } else {
      sessionStorage.setItem('is-no-degree-' + productId, false);
    }
    changeVariant(type, variantName);
    updateProgressBar(3, title);
    goToNextStep(4);
  });
  // choose how to input prescription on step 4
  $(document).on('click', '.prescription-option-click:not([data-function="lens-scanner"]):not(.no-saved-prescription)', function(e) {
    e.preventDefault();
    var func = $(this).data('function');
    var title = $(this).find('h5').text();
    sessionStorage.setItem('prod-prescription-' + productId, title);
    sessionStorage.setItem('prod-prescription-data-' + productId, '');
    $('#prescription-information').text(title).change();
    updateProgressBar(4, title);
    // remove required from upload file input to make sure not prevent other method
    $('#prescription-file').prop('required', false);
    $('.upload-file-input-wrapper').removeClass('active');
    $('.bottom-progress-wrapper').removeClass('show-submit-prescription-btn');
    if (func == 'in-store-check') {
      // update session storage
      changeVariant('cylinder', 'astigmatism between -0.00 to -2.00');
      initReview('in-store-check');
      goToNextStep(5);
    } else if (func == 'for-no-degree') {
      // update session storage
      changeVariant('cylinder', 'astigmatism between -0.00 to -2.00');
      initReview('for-no-degree');
      goToNextStep(5);
    } else {
      if (customerId != '') {
        $(this).parent().addClass('hidden');
        $(this).closest('.enter-prescription').find('.product-step-title').addClass('hidden');
        $('.prescription-type').addClass('hidden');
        $('.prescription-type[data-function='+ func +']').removeClass('hidden');
        if (func == 'upload-file') {
          changeVariant('cylinder', 'astigmatism between -0.00 to -2.00');
          $('#prescription-file').prop('required', true);
          $('.upload-file-input-wrapper').addClass('active');
        }
        if (func == 'enter-manually') {
          $('.bottom-progress-wrapper').addClass('show-submit-prescription-btn');
        }
        scrollToTop();
      } else {
        // set checkpoint then redirect to login page
        sessionStorage.setItem('checkpoint-product-url', productUrl);
        window.location.href = '/account/login';
      }
    }
  });

  // trigger choose in-store-check when click on to-free-eye-check link
  $(document).on('click', '.to-free-eye-check', function(e) {
    e.preventDefault();
    $('.prescription-option-click[data-function="in-store-check"]').trigger('click');
  });

  // limit file size
  $("#prescription-file").on("change", function (e) {
    if ($('#prescription-file').val()) {
      var files = e.currentTarget.files;
      for (var x in files) {
        var filesize = ((files[x].size/1024)/1024).toFixed(4); // MB
        if (filesize > 10) {
          $("#prescription-file").val('');
          $('.prescription-file-message').addClass('hidden');
          $('.prescription-file-message-size').removeClass('hidden');
        }
      }
    }
  });
  // action when upload prescription file
  $(document).on('click', '.prescription-file-submit', function(e) {
    e.preventDefault();
    if ($('#prescription-file').val()) {
      var prescriptionFileName = $('#prescription-file').val().replace('C:\\fakepath\\', '');
      sessionStorage.setItem('prod-prescription-data-' + productId, prescriptionFileName);
      $('.prescription-file-message').addClass('hidden');
      $('.upload-file-input-wrapper').removeClass('active');
      initReview('upload-file');
      goToNextStep(5);
    } else {
      $('.prescription-file-message').addClass('hidden');
      $('.prescription-file-message-require').removeClass('hidden');
    }
  });

  // action when choose prescription from my account
  $(document).on('click', '.prescription-list > li', function(e) {
    e.preventDefault();
    var rightCylinder = parseFloat($(this).data('right-cylinder'));
    var leftCylinder = parseFloat($(this).data('left-cylinder'));
    var cylinder = 'astigmatism between -0.00 to -2.00';
    if ((rightCylinder <= -2.25 && rightCylinder >= -4) || (leftCylinder <= -2.25 && leftCylinder >= -4)) {
      cylinder = 'astigmatism between -2.25 to -4.00';
    }
    if (rightCylinder < -4 || leftCylinder < -4) {
      cylinder = 'astigmatism between -4.25 & above';
    }
    changeVariant('cylinder', cylinder);
    var title = 'Select from my account';
    var prescriptionData = {
      'prescription_name': $(this).data('prescription-name'),
      'right_sphere': $(this).data('right-sphere'),
      'right_cylinder': $(this).data('right-cylinder'),
      'right_axis': $(this).data('right-axis'),
      'left_sphere': $(this).data('left-sphere'),
      'left_cylinder': $(this).data('left-cylinder'),
      'left_axis': $(this).data('left-axis'),
      'pupil_distance': $(this).data('pupil-distance')
    };
    var prescriptionText = 'Name: ' + prescriptionData['prescription_name'] + '\r\n' +
      'Right Sphere: ' + prescriptionData['right_sphere'] + '\r\n' +
      'Right Cylinder: ' + prescriptionData['right_cylinder'] + '\r\n' +
      'Right Axis: ' + prescriptionData['right_axis'] + '\r\n' +
      'Left Sphere: ' + prescriptionData['left_sphere'] + '\r\n' +
      'Left Cylinder: ' + prescriptionData['left_cylinder'] + '\r\n' +
      'Left Axis: ' + prescriptionData['left_axis'] + '\r\n' +
      'PD: ' + prescriptionData['pupil_distance'];
    var otherInformationText = 'Pupil Distance: ' + prescriptionData['pupil_distance'] + '\r\n' +
      'Prescription Name: ' + prescriptionData['prescription_name'];
    $('#prescription-information').text(prescriptionText).change();
    $('#prescription-other-information').text(otherInformationText).change();
    // update session storage
    sessionStorage.setItem('prod-prescription-' + productId, title);
    sessionStorage.setItem('prod-prescription-data-' + productId, JSON.stringify(prescriptionData));
    initReview('select-from-account');
    // update bottom progress bar
    updateProgressBar(4, title);
    goToNextStep(5);
  });

  // update content for step 5 review product before purchase
  function initReview(func) {
    var typeOfLens = sessionStorage.getItem('prod-type-of-lens-' + productId);
    var lensIndex = sessionStorage.getItem('prod-lens-index-' + productId);
    var prescriptionName = sessionStorage.getItem('prod-prescription-' + productId);
    var prescriptionData = '';
    var prescriptionDataHTML = '';
    if (sessionStorage.getItem('prod-prescription-data-' + productId) != '' && func != 'in-store-check' && func != 'for-no-degree') {
      if (func == 'upload-file') {
        prescriptionDataHTML = sessionStorage.getItem('prod-prescription-data-' + productId);
      } else {
        prescriptionData = JSON.parse(sessionStorage.getItem('prod-prescription-data-' + productId));
        prescriptionDataHTML = '<ul><li>'+ prescriptionData['prescription_name'] +'</li></ul>' +
          '<ul>' +
          '<li>Right eye:</li>' +
          '<li><dt>Sphere (Od)</dt><dd>' + prescriptionData['right_sphere'] + '</dd></li>' +
          '<li><dt>Cylinder (Od)</dt><dd>' + prescriptionData['right_cylinder'] + '</dd></li>' +
          '<li><dt>Axis (Od)</dt><dd>' + prescriptionData['right_axis'] + '</dd></li>' +
          '</ul><ul>' +
          '<li>Left eye:</li>' +
          '<li><dt>Sphere (Os)</dt><dd>' + prescriptionData['left_sphere'] + '</dd></li>' +
          '<li><dt>Cylinder (Os)</dt><dd>' + prescriptionData['left_cylinder'] + '</dd></li>' +
          '<li><dt>Axis (Os)</dt><dd>' + prescriptionData['left_axis'] + '</dd></li>' +
          '</ul><ul>' +
          '<li><dt>Pupil Distance</dt><dd>' + prescriptionData['pupil_distance'] + '</dd></li>' +
          '</ul>';
      }
    }
    $('.product-step-5 .review-type-of-lens').text(typeOfLens);
    $('.product-step-5 .review-lens-index').text(lensIndex);
    $('.product-step-5 .review-prescription h4').text(prescriptionName);
    $('.product-step-5 .review-prescription .review-prescription-desc').html(prescriptionDataHTML);
    $('.product-step-5 .review-product-total').html($('.product__price').html());
  }
  // update price on product progress bar
  function updateProgressBar(currentStep, value) {
    $('.bottom-progress-wrapper').removeClass('hidden');
    $('.bottom-progress-wrapper').attr('data-current-step', currentStep);
    $('.template-product .product-single .product-single__content').attr('data-current-step', currentStep);
    // update value for each step
    $('.bottom-progress-wrapper .progress-step').removeClass('active');
    $('.bottom-progress-wrapper .progress-step-' + currentStep).addClass('active').removeClass('deactive');
    if (currentStep == 2 || currentStep == 3 || currentStep == 4) {
      if (value != '') {
        $('.bottom-progress-wrapper .progress-step-' + currentStep + ' .progress-value').text(value);
        $('.bottom-progress-wrapper .progress-step-' + currentStep).addClass('has-value');
      }
    }
    // update subtotal price
    if (!$('.product__price > .price').hasClass('price--unavailable')) {
      $('.bottom-progress-wrapper .subtotal-value').html($('.product__price').html());
    }
    var height = $('.bottom-progress-wrapper').height();
    $('#PageContainer').css('padding-bottom', height);

  }
  // go to step content
  function goToNextStep(step) {
    if ($('.product-step-' + step).length) {
      updateProgressBar(step, '');
      $('.product-step').addClass('hidden');
      $('.product-step-' + step).removeClass('hidden');
      if (step == 5) {
        $('.product-form .product-form__controls-group--submit').addClass('active');
        $('.product-single .product-single__content .product-title').addClass('hidden');
        $('.bottom-progress-wrapper').removeClass('show-submit-prescription-btn');
        $('#PageContainer').css('padding-bottom', '0');
      } else {
        $('.product-form .product-form__controls-group--submit').removeClass('active');
        $('.product-single .product-single__content .product-title').removeClass('hidden');
      }
      if (step == 1) {
        $('.bottom-progress-wrapper').addClass('hidden');
        $('.product-single .product-single__description').removeClass('hidden');
        $('.product-recommendations-wrapper').removeClass('hidden');
        $('.signature-feature').removeClass('hidden');
        $('.product__price').removeClass('opacity-0');
        $('.product-single .go-back-btn').addClass('hidden');
      } else {
        $('.product-single .go-back-btn').removeClass('hidden');
        $('.product-single .product-single__description').addClass('hidden');
        $('.product-recommendations-wrapper').addClass('hidden');
        $('.signature-feature').addClass('hidden');
        $('.product__price').addClass('opacity-0');
      }
      if (step == 4) {
        var isNoDegree = sessionStorage.getItem('is-no-degree-' + productId);
        if (isNoDegree == 'true') {
          // redirect to last step when choose no degree lens
          $('.product-step.product-step-4 .enter-prescription>ul>li[data-function="for-no-degree"]').trigger('click');
        } else {
          $('.product-step.product-step-4 .enter-prescription>ul>li').removeClass('hidden');
        }
      }
      scrollToTop();
    }
  }
  //trigger change product variant
  function changeVariant(type, title) {
    $('select[data-option-name="' + type + '"] option').each(function() {
      if (title.toLowerCase() == $(this).val().toLowerCase()) {
        $('select[data-option-name="' + type + '"]').val($(this).val()).trigger('change');
        try {
            // For modern browsers except IE:
            var event = new CustomEvent('change', {detail:detail});
        } catch(err) {
          // If IE 11 (or 10 or 9...?) do it this way:
          // Create the event.
          var event = document.createEvent('Event');
          // Define that the event name is 'build'.
          event.initEvent('change', true, true);
        }
        document.querySelector('select[data-option-name="' + type + '"]').dispatchEvent(event);
      }
    });
  }

  // scroll to title of step if needed
  function scrollToTop() {
    if ($(document).scrollTop() > $('.template-product .main-content .product-single__right').offset().top) {
      var stickyHeaderHeight = 0;
      if ($('.header-main-top.nav-up').length) {
        stickyHeaderHeight = $('.header-main-top.nav-up').height();
      }
      var scrollTopVal = $('.template-product .main-content .product-single__right').offset().top;
      if (scrollTopVal >= stickyHeaderHeight) {
        scrollTopVal = scrollTopVal - stickyHeaderHeight;
      }
      $('html, body').animate({
        scrollTop: scrollTopVal
      }, 300);
    }
  }
  // add new prescription form
  $(document).on('click', '.prescription-form-class input[type="submit"]', function() {
    if ($(this).closest('.prescription-form-class').find('#input-name').val() != '') {
      $(this).closest('.prescription-form-class').find('.submit-prescription-wrapper').addClass('loading');
      $('.bottom-progress-wrapper .mobile-actions .trigger-submit-prescription-form').addClass('loading');
    }
  });
  $('body>.tooltip').remove();

  // check duplicate prescription
  $(document).on('click', '.prescription-form-class .submit-check-duplicate-name', function(e) {
    e.preventDefault();
    var pForm = $(this).closest('.prescription-form-class');
    if (pForm.find('#input-name').val() == '') {
      pForm.find('#prescription_error_message').text('This field is required.');
    } else {
      // compare with current prescription list
      var name = pForm.find('#input-name').val();
      var is_existed = false;
      $('.product-step-4 [data-function="select-from-account"] .prescription-list > li').each(function() {
        if (name.toString().trim().toLowerCase() == $(this).data('prescription-name').toString().trim().toLowerCase()) {
          is_existed = true;
        }
      });
      // submit
      if (is_existed) {
        pForm.find('#prescription_error_message').text('Name is already existed');
      } else {
        pForm.find('input[type="submit"]').trigger('click');
        pForm.find('#prescription_error_message').text('');
      }
    }
  });

  // Accentuate(jQuery("#prescription-form"), function(data) {
  //   $('#prescription-form .submit-prescription-wrapper').removeClass('loading');
  //   $('.bottom-progress-wrapper .mobile-actions .trigger-submit-prescription-form').removeClass('loading');
  //   if ('OK' == data.status) {
  //     var title = 'Enter manually';
  //     var prescriptionData = {
  //       'prescription_name': $('#prescription-form input[name="metafield[accentuate.prescription_name]"]').val(),
  //       'right_sphere': $('#prescription-form select[name="metafield[accentuate.right_sphere]"]').val(),
  //       'right_cylinder': $('#prescription-form select[name="metafield[accentuate.right_cylinder]"]').val(),
  //       'right_axis': $('#prescription-form select[name="metafield[accentuate.right_axis]"]').val(),
  //       'left_sphere': $('#prescription-form select[name="metafield[accentuate.left_sphere]"]').val(),
  //       'left_cylinder': $('#prescription-form select[name="metafield[accentuate.left_cylinder]"]').val(),
  //       'left_axis': $('#prescription-form select[name="metafield[accentuate.left_axis]"]').val(),
  //       'pupil_distance': $('#prescription-form select[name="metafield[accentuate.pupil_distance]"]').val()
  //     };
  //     var prescriptionText = 'Name: ' + prescriptionData['prescription_name'] + '\r\n' +
  //       'Right Sphere: ' + prescriptionData['right_sphere'] + '\r\n' +
  //       'Right Cylinder: ' + prescriptionData['right_cylinder'] + '\r\n' +
  //       'Right Axis: ' + prescriptionData['right_axis'] + '\r\n' +
  //       'Left Sphere: ' + prescriptionData['left_sphere'] + '\r\n' +
  //       'Left Cylinder: ' + prescriptionData['left_cylinder'] + '\r\n' +
  //       'Left Axis: ' + prescriptionData['left_axis'] + '\r\n' +
  //       'PD: ' + prescriptionData['pupil_distance'];
  //     var otherInformationText = 'Pupil Distance: ' + prescriptionData['pupil_distance'] + '\r\n' +
  //       'Prescription Name: ' + prescriptionData['prescription_name'];
  //     $('#prescription-information').text(prescriptionText).change();
  //     $('#prescription-other-information').text(otherInformationText).change();
  //     var rightCylinder = parseFloat(prescriptionData['right_cylinder']);
  //     var leftCylinder = parseFloat(prescriptionData['left_cylinder']);
  //     var cylinder = 'astigmatism between -0.00 to -2.00';
  //     if ((rightCylinder <= -2.25 && rightCylinder >= -4) || (leftCylinder <= -2.25 && leftCylinder >= -4)) {
  //       cylinder = 'astigmatism between -2.25 to -4.00';
  //     }
  //     if (rightCylinder < -4 || leftCylinder < -4) {
  //       cylinder = 'astigmatism between -4.25 & above';
  //     }
  //     changeVariant('cylinder', cylinder);
  //     // update session storage
  //     sessionStorage.setItem('prod-prescription-' + productId, title);
  //     sessionStorage.setItem('prod-prescription-data-' + productId, JSON.stringify(prescriptionData));
  //     initReview('enter-manually');
  //     // update bottom progress bar
  //     updateProgressBar(4, title);
  //     // update prescription list
  //     var lastIndex = 0;
  //     if ($('.product-step-4 [data-function="select-from-account"] .prescription-list > li').length) {
  //       lastIndex = parseInt($('.product-step-4 [data-function="select-from-account"] .prescription-list > li:last-child').data('index')) + 1;
  //     }
  //     var newPrescriptionHTML = '<li data-index="'+ lastIndex +'" '
  //       + 'data-prescription-name="'+ prescriptionData['prescription_name'] +'" '
  //       + 'data-right-sphere="'+ prescriptionData['right_sphere'] +'" '
  //       + 'data-right-cylinder="'+ prescriptionData['right_cylinder'] +'" '
  //       + 'data-right-axis="'+ prescriptionData['right_axis'] +'" '
  //       + 'data-left-sphere="'+ prescriptionData['left_sphere'] +'" '
  //       + 'data-left-cylinder="'+ prescriptionData['left_cylinder'] +'" '
  //       + 'data-left-axis="'+ prescriptionData['left_axis'] +'" '
  //       + 'data-pupil-distance="'+ prescriptionData['pupil_distance'] +'">'
  //       + '<h3>'+ prescriptionData['prescription_name'] +'</h3>'
  //       + '<table>'
  //       + '<thead><tr><td></td><td>Sphere</td><td>Cylinder</td></tr></thead>'
  //       + '<tbody><tr><td>Right</td><td>'+ prescriptionData['right_sphere'] +'</td><td>'+ prescriptionData['right_cylinder'] +'</td></tr><tr><td>Left</td><td>'+ prescriptionData['left_sphere'] +'</td><td>'+ prescriptionData['left_cylinder'] +'</td></tr></tbody>'
  //       + '</table></li>';
  //     $('.product-step-4 [data-function="select-from-account"] .prescription-list').append(newPrescriptionHTML);
  //     // show success message
  //     alert('New prescription has been saved to your profile.');
  //     goToNextStep(5);
  //   } else {
  //     alert('Error');
  //   }
  // });
  // Accentuate(jQuery("#prescription-form-scanner"), function(data) {
  //   $('#prescription-form-scanner .submit-prescription-wrapper').removeClass('loading');
  //   $('.bottom-progress-wrapper .mobile-actions .trigger-submit-prescription-form').removeClass('loading');
  //   if ('OK' == data.status) {
  //     var title = 'foptics lens scanner';
  //     var prescriptionData = {
  //       'prescription_name': $('#prescription-form-scanner input[name="metafield[accentuate.prescription_name]"]').val(),
  //       'right_sphere': $('#prescription-form-scanner select[name="metafield[accentuate.right_sphere]"]').val(),
  //       'right_cylinder': $('#prescription-form-scanner select[name="metafield[accentuate.right_cylinder]"]').val(),
  //       'right_axis': $('#prescription-form-scanner select[name="metafield[accentuate.right_axis]"]').val(),
  //       'left_sphere': $('#prescription-form-scanner select[name="metafield[accentuate.left_sphere]"]').val(),
  //       'left_cylinder': $('#prescription-form-scanner select[name="metafield[accentuate.left_cylinder]"]').val(),
  //       'left_axis': $('#prescription-form-scanner select[name="metafield[accentuate.left_axis]"]').val(),
  //       'pupil_distance': $('#prescription-form-scanner select[name="metafield[accentuate.pupil_distance]"]').val()
  //     };
  //     var prescriptionText = 'Name: ' + prescriptionData['prescription_name'] + '\r\n' +
  //       'Right Sphere: ' + prescriptionData['right_sphere'] + '\r\n' +
  //       'Right Cylinder: ' + prescriptionData['right_cylinder'] + '\r\n' +
  //       'Right Axis: ' + prescriptionData['right_axis'] + '\r\n' +
  //       'Left Sphere: ' + prescriptionData['left_sphere'] + '\r\n' +
  //       'Left Cylinder: ' + prescriptionData['left_cylinder'] + '\r\n' +
  //       'Left Axis: ' + prescriptionData['left_axis'] + '\r\n' +
  //       'PD: ' + prescriptionData['pupil_distance'];
  //     var otherInformationText = 'Pupil Distance: ' + prescriptionData['pupil_distance'] + '\r\n' +
  //       'Prescription Name: ' + prescriptionData['prescription_name'];
  //     $('#prescription-information').text(prescriptionText).change();
  //     $('#prescription-other-information').text(otherInformationText).change();
  //     var rightCylinder = parseFloat(prescriptionData['right_cylinder']);
  //     var leftCylinder = parseFloat(prescriptionData['left_cylinder']);
  //     var cylinder = 'astigmatism between -0.00 to -2.00';
  //     if ((rightCylinder <= -2.25 && rightCylinder >= -4) || (leftCylinder <= -2.25 && leftCylinder >= -4)) {
  //       cylinder = 'astigmatism between -2.25 to -4.00';
  //     }
  //     if (rightCylinder < -4 || leftCylinder < -4) {
  //       cylinder = 'astigmatism between -4.25 & above';
  //     }
  //     changeVariant('cylinder', cylinder);
  //     // update session storage
  //     sessionStorage.setItem('prod-prescription-' + productId, title);
  //     sessionStorage.setItem('prod-prescription-data-' + productId, JSON.stringify(prescriptionData));
  //     initReview('lens-scanner');
  //     // update bottom progress bar
  //     updateProgressBar(4, title);
  //     // update prescription list
  //     var lastIndex = 0;
  //     if ($('.product-step-4 [data-function="select-from-account"] .prescription-list > li').length) {
  //       lastIndex = parseInt($('.product-step-4 [data-function="select-from-account"] .prescription-list > li:last-child').data('index')) + 1;
  //     }
  //     var newPrescriptionHTML = '<li data-index="'+ lastIndex +'" '
  //       + 'data-prescription-name="'+ prescriptionData['prescription_name'] +'" '
  //       + 'data-right-sphere="'+ prescriptionData['right_sphere'] +'" '
  //       + 'data-right-cylinder="'+ prescriptionData['right_cylinder'] +'" '
  //       + 'data-right-axis="'+ prescriptionData['right_axis'] +'" '
  //       + 'data-left-sphere="'+ prescriptionData['left_sphere'] +'" '
  //       + 'data-left-cylinder="'+ prescriptionData['left_cylinder'] +'" '
  //       + 'data-left-axis="'+ prescriptionData['left_axis'] +'" '
  //       + 'data-pupil-distance="'+ prescriptionData['pupil_distance'] +'">'
  //       + '<h3>'+ prescriptionData['prescription_name'] +'</h3>'
  //       + '<table>'
  //       + '<thead><tr><td></td><td>Sphere</td><td>Cylinder</td></tr></thead>'
  //       + '<tbody><tr><td>Right</td><td>'+ prescriptionData['right_sphere'] +'</td><td>'+ prescriptionData['right_cylinder'] +'</td></tr><tr><td>Left</td><td>'+ prescriptionData['left_sphere'] +'</td><td>'+ prescriptionData['left_cylinder'] +'</td></tr></tbody>'
  //       + '</table></li>';
  //     $('.product-step-4 [data-function="select-from-account"] .prescription-list').append(newPrescriptionHTML);
  //     // show success message
  //     alert('New prescription has been saved to your profile.');
  //     goToNextStep(5);
  //   } else {
  //     alert('Error');
  //   }
  // });

  // Back to current step after logged in
  if (sessionStorage.getItem('checkpoint-product-continue')) {
    sessionStorage.removeItem('checkpoint-product-continue');
    var currentTypeOfLens = sessionStorage.getItem('prod-type-of-lens-' + productId);
    var currentLensIndex = sessionStorage.getItem('prod-lens-index-' + productId);
    var currentPrescription = sessionStorage.getItem('prod-prescription-' + productId);
    updateProgressBar(1, '');
    goToNextStep(2);
    if (currentTypeOfLens != '') {
      $('.product-step-2 .option-list li h4').each(function() {
        if ($(this).text() == currentTypeOfLens) {
          $(this).closest('li').trigger('click');
        }
      });
    }
    if (currentLensIndex != '') {
      $('.product-step-3 .option-list li h4').each(function() {
        if ($(this).text() == currentLensIndex) {
          $(this).closest('li').trigger('click');
        }
      });
    }
    if (currentPrescription != '') {
      $('.prescription-option-click h5').each(function() {
        if ($(this).text() == currentPrescription) {
          var self = this;
          setTimeout(function() {
            $(self).closest('li').trigger('click');
          }, 200);
        }
      });
    }
  }

  // to display results on product page when scan is complete if user is not logged in
  if (sessionStorage.getItem('display-results')) {
    const prescriptionResults = JSON.parse(sessionStorage.getItem('results'))
    displayResultsOnProductPage(prescriptionResults)
    sessionStorage.removeItem('display-results')
    sessionStorage.removeItem('results')
  }

  // go to specific step when clicking on progress bar
  $(document).on('click', '.bottom-progress-wrapper .progress-step a', function(e) {
    e.preventDefault();
    if (!$(this).parent().hasClass('active')) {
      var step = $(this).data('step');
      if ($('.bottom-progress-wrapper .progress-step-' + step).length) {
        $('.bottom-progress-wrapper .progress-step').removeClass('active');
        $('.bottom-progress-wrapper .progress-step-' + step).addClass('active');
        $('.bottom-progress-wrapper .progress-step-' + step + ' ~ .progress-step').addClass('deactive');
        $('.bottom-progress-wrapper .progress-step-' + step + ' ~ .progress-step .progress-value').text('');
        $('.bottom-progress-wrapper .progress-step-' + step + ' ~ .progress-step').removeClass('has-value');
        // remove unnecessary attribute from step4 sub content that prevent function
        $('#prescription-file').prop('required', false).val('');
        $('.upload-file-input-wrapper').removeClass('active');
        $('.bottom-progress-wrapper').removeClass('show-submit-prescription-btn');
        //hide step 4 content if step < 4
        if (step <= 4) {
          $('.product-step-4 .prescription-type').addClass('hidden');
          $('.product-step-4 .product-step-title').removeClass('hidden');
          $('.product-step-4 .enter-prescription > ul').removeClass('hidden');
        }
        if ($('.bottom-progress-wrapper .progress-step-' + step + ' .progress-value').text() == 'No degree') {
          goToNextStep(3);
          $('.bottom-progress-wrapper .left-progress ul li.progress-step-3').addClass('active');
          $('.bottom-progress-wrapper .left-progress ul li.progress-step-4').addClass('deactive');
          $('.bottom-progress-wrapper .left-progress ul li.progress-step-4 .progress-value').text('');
        } else {
          goToNextStep(step);
        }
      }
    }
  });
  // go back to previous step when clicking on arrow mobile of progress bar
  $(document).on('click', '.bottom-progress-wrapper .go-back-step', function(e) {
    e.preventDefault();
    if ($('.bottom-progress-wrapper[data-current-step="5"]').length) {
      $('.bottom-progress-wrapper .left-progress ul li.progress-step-4 a').trigger('click');
    } else {
      if ($('.product-step-4 .enter-prescription > ul.hidden').length && $('.bottom-progress-wrapper .left-progress ul li.progress-step-4.active').length) {
        $('.product-step-4 .enter-prescription > ul.hidden').removeClass('hidden');
        $('.product-step-4 .enter-prescription > .product-step-title.hidden').removeClass('hidden');
        $('.prescription-type').addClass('hidden');
        $('.upload-file-input-wrapper').removeClass('active');
        $('#prescription-file').prop('required', false);
      } else {
        $('.bottom-progress-wrapper .left-progress ul li.progress-step.active').prev().find('a').trigger('click');
      }
    }
  });
  // go back to previous step when clicking on BACK
  $(document).on('click', '.template-product .go-back-btn', function(e) {
    e.preventDefault();

    // after scan is completed and prescription is saved, clicking "BACK" displays lens scanner
    // to close manually
    var glassesOnCloseButton = document.getElementsByClassName('go_close')[0]
    if (glassesOnCloseButton) {
      glassesOnCloseButton.click()
    }

    if ($('.bottom-progress-wrapper[data-current-step="5"]').length) {
      $('.bottom-progress-wrapper .left-progress ul li.progress-step-4 a').trigger('click');
    } else {
      if ($('.product-step-4 .enter-prescription > ul.hidden').length && $('.bottom-progress-wrapper .left-progress ul li.progress-step-4.active').length) {
        $('.product-step-4 .enter-prescription > ul.hidden').removeClass('hidden');
        $('.product-step-4 .enter-prescription > .product-step-title.hidden').removeClass('hidden');
        $('.prescription-type').addClass('hidden');
        $('.upload-file-input-wrapper').removeClass('active');
        $('#prescription-file').prop('required', false);
      } else {
        $('.bottom-progress-wrapper .left-progress ul li.progress-step.active').prev().find('a').trigger('click');
      }
    }
  });
  // trigger click button submit prescription form on step 4
  $(document).on('click', '.bottom-progress-wrapper .trigger-submit-prescription-form', function(e) {
    e.preventDefault();
    $('.product-step.product-step-4 .enter-prescription #prescription-form input[type="submit"]').trigger('click');
  });
  // trigger click button add to cart on step 5
  $(document).on('click', '.bottom-progress-wrapper .trigger-add-to-cart', function(e) {
    e.preventDefault();
    $('.product-form-product-template .product-form__controls-group--submit button[data-add-to-cart]').trigger('click');
  });

  // Scanning app
  $('.prescription-option-click[data-function="lens-scanner"]').on('click', function(e) {
    if (!$(e.target).hasClass('ios-link') && !$(e.target).hasClass('android-link') && !$(e.target).hasClass('learn-link')) {
      var title = $(this).find('h5').text();
      sessionStorage.setItem('prod-prescription-' + productId, title);
      open_glasseson();
    }
  });
  function open_glasseson() {
    var options = {
      themeColor: "#5FB8E3",
      fontFamily: "Arial",
      profileName: scanningProfileName // provided by 6over6
    };
    var clientId = scanningClientId; // provided by 6over6
    var serverUrl = scanningServerUrl; // provided by 6over6
    glasseson_wc.init(clientId, serverUrl, options).then(
      response => {
        handleSuccess();
      },
      error => {
        handleError(error);
      }
    );
  };
  function handleSuccess() {
    glasseson_wc.setResultCallback(resultCallback);
    glasseson_wc.open().then(
      response => {
        // shopify fix won't be needed in the future versions.
        document.getElementById("glasseson_wc").style.zIndex = "10000";
      },
      error => {
      }
    );
  };
  function handleError(error) {
    console.log(error);
  };
  function resultCallback(result) {
    if (result.isFlowComplete) {
      glasseson_wc.close();
      if (customerId === '') {
        sessionStorage.setItem('checkpoint-product-url', productUrl);
        sessionStorage.setItem('results', JSON.stringify(result))
        sessionStorage.setItem('display-results', true)
        window.location.href = '/account/login';
      } else {
        displayResultsOnProductPage(result)
        scrollToTop();
      }
    }
  };

  function displayResultsOnProductPage(result) {
    var l_sph = result.prescription.l_sph;
    var r_sph = result.prescription.r_sph;

    if (parseFloat(result.prescription.l_sph) > 0 && result.prescription.l_sph.indexOf('+') < 0) {
      l_sph = '+' + result.prescription.l_sph;
    }
    if (parseFloat(result.prescription.r_sph) > 0 && result.prescription.r_sph.indexOf('+') < 0) {
      r_sph = '+' + result.prescription.r_sph;
    }
    $('#l_sph').val(l_sph);
    $('#r_sph').val(r_sph);
    $('#l_cyl').val(result.prescription.l_cyl);
    $('#r_cyl').val(result.prescription.r_cyl);
    $('#l_axis').val(result.prescription.l_axis);
    $('#r_axis').val(result.prescription.r_axis);
    $('#pd').val(result.prescription.pd+'mm');

    // FOT function
    var title = $('.prescription-option-click[data-function="lens-scanner"]').find('h5').text();
    sessionStorage.setItem('prod-prescription-' + productId, title);
    sessionStorage.setItem('prod-prescription-data-' + productId, '');
    $('#prescription-information').text(title).change();
    updateProgressBar(4, title);
    // remove required from upload file input to make sure not prevent other method
    $('#prescription-file').prop('required', false);
    $('.upload-file-input-wrapper').removeClass('active');
    $('.bottom-progress-wrapper').removeClass('show-submit-prescription-btn');
    $('.prescription-option-click[data-function="lens-scanner"]').parent().addClass('hidden');
    $('.prescription-option-click[data-function="lens-scanner"]').closest('.enter-prescription').find('.product-step-title').addClass('hidden');
    $('.prescription-type').addClass('hidden');
    $('.prescription-type[data-function="lens-scanner"]').removeClass('hidden');
  }
});